import { useAISummaryStore } from "../../store/aiSummaryStore";
import CaseDropdown from "../Fields/CaseDropdown";
import CopyNoteActionsMenu from "../Fields/CopyNoteActionsMenu";

export default function RightTopPanel() {
  const { showRightTopBar } = useAISummaryStore();

  return (
    showRightTopBar && (
      <div className="flex w-full flex-row items-end justify-between p-2">
        <div className="w-3/5 h-full">
          <CaseDropdown label={"Case"} placeholder="Select an option" />
        </div>
        <CopyNoteActionsMenu />
      </div>
    )
  );
}
